<template>
  <div class="customerInfo">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <div class="title">{{ $t.enterpriseInfo.title }}</div>
      <van-field
        v-model="CustomerNumber"
        :label="$t.information.customerNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(CustomerNumber)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field :label="$t.meta.customerTitle">
        <template #input>
          <van-radio-group v-model="form.CustomerType" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
            <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        :value="country.text"
        :label="$t.meta.country"
        :name="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowCountry"
        required
        :rules="formRule"
      />
      <van-field
        readonly
        clickable
        :value="city.text"
        :label="$t.meta.city"
        :name="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowCity"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.CompanyName"
        :label="$t.information.companyName"
        :name="$t.information.companyName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.PersonalID"
        :label="$t.information.personalIDSn"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.PersonalPassport"
        :label="$t.information.personalPassport"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.CustomerPhone"
        :label="$t.information.customerPhone"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.Password"
        :label="$t.information.customerPassword"
        :placeholder="$t.information.input"
        type="password"
      />

      <van-field
        v-model="form.CompanyNameEn"
        :label="$t.information.companyNameEn"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.information.companyNameSn"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.LegalPerson"
        :label="$t.information.legalPerson"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.TelePhone"
        :label="$t.information.telePhone"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.WebSite"
        :label="$t.information.webSite"
        :placeholder="$t.information.input"
      />
      <van-field :label="$t.enterpriseInfo.licence">
        <template #input>
          <van-uploader v-model="certificate" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <div class="tool-bar" v-if="!this.form.CustomerModifyCount">
        <van-button block type="info" native-type="submit">{{
          $t.information.submit
        }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showCustomerHomeCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showCustomerHomeCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Radio, RadioGroup } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Uploader).use(Icon).use(Radio).use(RadioGroup);

export default {
  name: "customerInfo",
  components: {
    OptionList,
  },
  data() {
    return {
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      CustomerNumber: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerNumber,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      certificate: [],
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
    };
  },
  created() {
    this.getCountrys().then((success) => {
      if (success) this.loadCustomerHomeInfo();
    });
  },
  methods: {
    getCountrys() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        let param = {
          BusinessType: 1,
        };
        this.$api.myCustomer
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + " , " + item.CountryName_en,
                value: item.CountryId,
                CityList: item.CityList,
              };
              result.push(data);
            });
            this.countryList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCities(countryId, isReset) {
      for (let country of this.countryList) {
        if (country.value == countryId) {
          var result = [];
          country.CityList.forEach((item) => {
            let data = {
              text: item.City_cn + " , " + item.City_en,
              value: item.CityId,
            };
            result.push(data);
          });
          this.cityList = result;

          if (isReset) {
            this.city = { text: "", value: "" };
          }
        }
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onShowCountry() {
      this.$bus.$emit("showCustomerHomeCountry", true);
    },
    onSelectCountry(item) {
      this.country.text = item.text;
      this.country.value = item.value;
      this.getCities(item.value, true);
    },
    onShowCity() {
      this.$bus.$emit("showCustomerHomeCity", true);
    },
    onSelectCity(item) {
      this.city.text = item.text;
      this.city.value = item.value;
    },
    loadCustomerHomeInfo() {
      this.$commonMethod.showLoading();
      var param = {
        CustomerId: this.CustomerId,
      };
      this.$api.customerManagement
        .loadCustomerHomeInfo(param)
        .then((res) => {
          this.form = res.data;
          if (this.form.Certificate) {
            this.certificate.push({
              url: this.imgUrlFilter(this.form.Certificate),
            });
          }
          //国家
          var country = this.countryList.find((c) => c.value == this.form.CountryId);
          if (country) {
            this.country.text = country.text;
            this.country.value = country.value;
            this.getCities(country.value);
          }
          //城市
          var city = this.cityList.find((c) => c.value == this.form.CityId);
          if (city) {
            this.city.text = city.text;
            this.city.value = city.value;
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CountryId = this.country.value;
      param.CityId = this.city.value;
      this.$api.customerManagement
        .customerInfoModifyCompanyInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.BusinessLicence = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.customerInfo {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field__value {
    overflow: visible !important;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
